import CircleIcon from '@mui/icons-material/Circle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';

const getTabOptions = status => {
  let options;
  switch (status) {
    case 'all':
      options = {
        Icon: CircleIcon,
        color: config().colors.secondary,
        name: 'All',
      };
      break;
    case 'NEW': 
      options = {
        Icon: CircleIcon,
        color: config().colors.primary,
        name: 'New',
      };
      break;
    default:
      options = {
        Icon: CircleIcon,
        color: config().colors.muted,
        name: 'NA',
      };
  }
  return options;
};

const LeadTab = props => {
  const {color, Icon, name} = getTabOptions(props.status);
  return (
    <Stack
      direction='row'
      spacing={{xs: 1.5}}
      alignItems='center'
      onClick={props.onClick || undefined}
    >
      <Icon style={{fill: color, width: '15px', height: '15px'}} />
      {
        <Typography
          variant='normal'
          noWrap
        >
          {name} ({props.statusCount})
        </Typography>
      }
    </Stack>
  );
}

const LeadTabs = props => {
  const { tab, tabs } = props;
  const tabFilters = tabs;

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'start', sm: 'center' }}
      columns={{ xs: 1 }}
      columnGap={{md: 4.25, lg: 8.75}}
      rowGap={{ xs: 0, md: 2 }}
      padding={{ xs: 0, md: 1 }}
      useFlexGap
    >
      {tabFilters
        .map(t =>
          <div
            onClick={() => { props.onTabChange(t) }}
          >
            <LeadTab
              status={t}
              active={t === tab}
              statusCount={props.counts[t]}
            />
          </div>
        )
      }
    </Stack>
  );
};

export default LeadTabs;